module.exports = __webpack_public_path__ + "static/media/reward_wallet_modal_asset_03.b871e2ec.svg";